<template>
  <div class="quote-container">
    <div class="quote-header">
      <a href="/">
        <rt-picture
          src="/assets/app/signup/icon-logo.svg"
          :autosize="false"
        />
      </a>
      <primary-button
        class="btn-normal btn-back"
        @click="moveBack"
      >
        Back
      </primary-button>
    </div>
    <div class="page-content">
      <QuoteForm
        :username="userName"
        :email="userEmail"
        :schoolName="schoolName"
        @onSuccess="isRequestSucceed=true"
        v-if="!isRequestSucceed"
      />
      <QuoteSuccessView
        @onClose="moveBack"
        v-else
      />
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import RtPicture from '../common/Picture.vue';
import PrimaryButton from '../common/PrimaryButton.vue';
import QuoteForm from './QuoteForm.vue';
import QuoteSuccessView from './QuoteSuccessView.vue';
import { getUser, isLoggedIn } from 'common/UserService';
import { getSchoolInfoForUser } from 'common/api';
import Utils from 'common/Utils';

export default {
  components: {
    RtPicture,
    PrimaryButton,
    QuoteForm,
    QuoteSuccessView
  },
  data() {
    return {
      user: getUser(),
      isRequestSucceed: false
    }
  },
  computed: {
    ...mapState('teacher', ['schoolInfo']),
    userName() {
      return this.user ? Utils.getFullname(this.user) : null;
    },
    userEmail() {
      return this.user ? this.user.email : null;
    },
    schoolName() {
      return this.schoolInfo ? this.schoolInfo.name : null;
    }
  },
  async mounted() {
    if (!this.schoolInfo && isLoggedIn()) {
      const result = await getSchoolInfoForUser(this.user?.id);
      if (result && result.data) {
        this.updateSchoolInfo(result.data);
      }
    }
  },
  methods: {
    ...mapMutations('teacher', ['updateSchoolInfo']),
    moveBack() {
      this.$emit('onBack');
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../common/variables';

.quote-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;

  .quote-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $light-blue8;
    padding: 20px 80px;

    .btn-back {
      font-weight: $font-bold;
      font-size: 14px;
      color: $primary-dark-blue;
      &:hover {
        color: $button_hover_bg_color;
      }
    }
  }

  .page-content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: $white;
    padding: 40px 0;
    overflow-y: auto;
  }
}

</style>